import clsx from 'clsx';
import React, { ElementType } from 'react';
import classes from './ProgressBar.module.scss';

export type Props<T extends ElementType = 'progress'> = {
  className?: string;
  style: 'linear' | 'circular';
  value: number | string;
  max: number | string;
} & React.ComponentProps<T>;

export const ProgressBar: React.FC<Props> = ({ className, style, ...rest }) => {
  function setCssVariables(el: HTMLDivElement | null) {
    if (el) {
      el.style.setProperty(
        '--progress-bar-percentage',
        `${(Number(rest.value) / Number(rest.max)) * 100}%`,
      );
    }
  }

  return (
    <div className={clsx(className, classes.root, classes[style])} ref={setCssVariables}>
      <progress className={clsx(classes.progress)} {...rest} />
    </div>
  );
};
